export default class EitherOrParticipationRequestModel {
  public pair: string = "";
  public answer: string = "";
}
